/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:45
 * @LastEditTime: 2022-08-03 15:00:38
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\component\personal\locales\zh-CN.ts
 */
export default {
    'page.personal.center.compontent.person.message' : '个人信息',
    'page.personal.center.compontent.person.nationality':'国籍',
    'page.personal.center.compontent.person.name':'姓名',
    'page.personal.center.compontent.person.EnName':'英文姓名',
    'page.personal.center.compontent.person.email':'邮箱',
    'page.personal.center.compontent.person.phone':'联系手机号',
    'page.personal.center.compontent.person.address':'联系地址',
    'page.personal.center.compontent.person.addressMod':'详细地址',
    'page.personal.center.compontent.person.select':'请选择联系地址',
    'page.personal.center.compontent.person.type':'证件类型',
    'page.personal.center.compontent.person.number':'证件号码',
    'page.personal.center.compontent.person.id':'身份证',
    'page.personal.center.compontent.person.passport':'护照',
    'page.personal.center.compontent.person.certificateTypes':'通行证',
    'page.personal.center.compontent.person.certificateValidity':'证件有效期',
    'page.personal.center.compontent.person.effective':'长期有效',
    'page.personal.center.compontent.person.certificate':'身份证头像面',
    'page.personal.center.compontent.person.reverseCertificate':'身份证国徽面',
    'page.personal.center.compontent.person.upload':'请上传清晰可见的证件照反面',
    'page.personal.center.compontent.person.size':'文件大小不超过10M',
    'page.personal.center.compontent.person.support':'文件格式支持',
    'page.personal.center.compontent.person.certificatez':'请上传清晰可见的证件照正面',
    'page.personal.center.compontent.person.submit':'提交',
    'page.personal.center.compontent.person.reset':'重置',

}
